// Generated by KlangScriptProcessor, DO NOT EDIT

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.builder.KlangScriptExtensionBuilder

/**
 * Registers all @KlangScript annotated symbols for the 'sprudel' library.
 */
fun KlangScriptExtensionBuilder.registerSprudelGenerated() {
    registerSprudelLangArithmeticChunk0()
    registerSprudelLangArithmeticChunk1()
    registerSprudelLangArithmeticChunk2()
    registerSprudelLangArithmeticChunk3()
    registerSprudelLangArithmeticChunk4()
    registerSprudelLangConditionalChunk0()
    registerSprudelLangContinuousChunk0()
    registerSprudelLangDynamicsChunk0()
    registerSprudelLangDynamicsChunk1()
    registerSprudelLangDynamicsChunk2()
    registerSprudelLangDynamicsChunk3()
    registerSprudelLangEffectsChunk0()
    registerSprudelLangEffectsChunk1()
    registerSprudelLangEffectsChunk2()
    registerSprudelLangEuclidChunk0()
    registerSprudelLangEuclidChunk1()
    registerSprudelLangFiltersChunk0()
    registerSprudelLangFiltersChunk1()
    registerSprudelLangFiltersChunk2()
    registerSprudelLangFiltersChunk3()
    registerSprudelLangKatalystChunk0()
    registerSprudelLangMasterChunk0()
    registerSprudelLangPickingChunk0()
    registerSprudelLangPickingChunk1()
    registerSprudelLangRandomChunk0()
    registerSprudelLangRandomChunk1()
    registerSprudelLangRandomChunk2()
    registerSprudelLangRandomChunk3()
    registerSprudelLangRandomChunk4()
    registerSprudelLangSampleChunk0()
    registerSprudelLangSampleChunk1()
    registerSprudelLangStructuralChunk0()
    registerSprudelLangStructuralChunk1()
    registerSprudelLangStructuralChunk2()
    registerSprudelLangStructuralChunk3()
    registerSprudelLangStructuralChunk4()
    registerSprudelLangStructuralChunk5()
    registerSprudelLangStructuralChunk6()
    registerSprudelLangStructuralChunk7()
    registerSprudelLangStructuralChunk8()
    registerSprudelLangStructuralChunk9()
    registerSprudelLangStructuralChunk10()
    registerSprudelLangSynthesisChunk0()
    registerSprudelLangSynthesisChunk1()
    registerSprudelLangSynthesisChunk2()
    registerSprudelLangSynthesisChunk3()
    registerSprudelLangSynthesisChunk4()
    registerSprudelLangTempoChunk0()
    registerSprudelLangTempoChunk1()
    registerSprudelLangTempoChunk2()
    registerSprudelLangTempoChunk3()
    registerSprudelLangTempoChunk4()
    registerSprudelLangTonalChunk0()
    registerSprudelLangTonalChunk1()
    registerSprudelLangTonalChunk2()
    registerSprudelLangTonalChunk3()

    // Auto-register documentation for code completion
    (this as? KlangScriptLibrary.Builder)?.docs { registerAll(generatedSprudelDocs) }
}
